import { useState } from 'react';
import { Platform } from 'react-native';
import { Button } from '@/common/components/Button/Button';
import { Card } from '@/common/components/Card/Card';
import { Divider } from '@/common/components/Divider/Divider';
import { Grid } from '@/common/components/Grid/Grid';
import { Icon } from '@/common/components/Icons/Icon';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { TabItem } from '@/common/components/Tabs/TabItem/TabItem';
import { Tabs } from '@/common/components/Tabs/Tabs';
import { PlaygroundAlerts } from '@/common/containers/Playground/PlaygroundAlerts.demo';
import { PlaygroundButtons } from '@/common/containers/Playground/PlaygroundButtons.demo';
import { PlaygroundCards } from '@/common/containers/Playground/PlaygroundCards.demo';
import { PlaygroundForms } from '@/common/containers/Playground/PlaygroundForms.demo';
import { PlaygroundIcons } from '@/common/containers/Playground/PlaygroundIcons.demo';
import { PlaygroundMiscellaneous } from '@/common/containers/Playground/PlaygroundMiscellaneous.demo';
import { PlaygroundModals } from '@/common/containers/Playground/PlaygroundModals.demo';
import { PlaygroundToasts } from '@/common/containers/Playground/PlaygroundToasts.demo';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';

const PLAYGROUND_ITEMS = [
  { id: 'Alerts', component: PlaygroundAlerts },
  { id: 'Buttons', component: PlaygroundButtons },
  { id: 'Cards', component: PlaygroundCards },
  { id: 'Forms', component: PlaygroundForms },
  { id: 'Icons', component: PlaygroundIcons },
  { id: 'Modals', component: PlaygroundModals },
  { id: 'Toasts', component: PlaygroundToasts },
  { id: 'Other', component: PlaygroundMiscellaneous },
] as const;

function CardItem({
  label,
  selected,
  onPress,
}: {
  label: string;
  selected: boolean;
  onPress: () => void;
}) {
  return (
    <Card
      onPress={onPress}
      className={`flex items-center justify-center rounded-xs p-1 ${
        selected ? 'text-white bg-accentPrimary20' : ''
      }`}
    >
      {label}
    </Card>
  );
}

export function PlaygroundPage() {
  const breakpoints = useBreakpoints(['sm']);
  const [selectedItem, setSelectedItem] = useState<
    (typeof PLAYGROUND_ITEMS)[number]
  >(PLAYGROUND_ITEMS[0]);

  return (
    <PageLayout
      headerProps={{
        title: 'Playground',
        primaryAction: (
          <Button icon={<Icon icon="plus" />}>Primary action</Button>
        ),
        backButton: true,
      }}
    >
      {Platform.OS !== 'web' || !breakpoints.sm ? (
        <Tabs>
          {PLAYGROUND_ITEMS.map(({ id, component: Component }) => (
            <TabItem key={id} label={id}>
              <Component />
            </TabItem>
          ))}
        </Tabs>
      ) : (
        <>
          <Grid gap="sm" columnBasis="basis-[15rem]">
            {PLAYGROUND_ITEMS.map((item) => (
              <CardItem
                key={item.id}
                label={item.id}
                selected={selectedItem?.id === item.id}
                onPress={() => setSelectedItem(item)}
              />
            ))}
          </Grid>
          <Divider />
          {selectedItem && <selectedItem.component />}
        </>
      )}
    </PageLayout>
  );
}
